"use strict";import{tag as a}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const ChevronRightIcon=({width:t=24,height:e=24,hidden:l=!1,title:r="Chevron Right"}={})=>a`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${e}"
    viewBox="0 0 36 36"
    width="${t}"
    aria-hidden=${l?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${r}"
  >
    <path
      d="M24 18a1.988 1.988 0 0 1-.585 1.409l-7.983 7.98a2 2 0 1 1-2.871-2.772l.049-.049L19.181 18l-6.572-6.57a2 2 0 0 1 2.773-2.87l.049.049 7.983 7.98A1.988 1.988 0 0 1 24 18Z"
    />
  </svg>`;
//# sourceMappingURL=ChevronRight.js.map
